import { browserHistory } from 'react-router';
import * as apiIntegration from '../../services/integration/api_integration';
import * as apiXero from '../../services/xero/api_xero';
import * as apiCommon from '../../services/apiCommon';
import * as sagaCommon from '../sagasCommon';

import { takeLatest, select, call, put, fork, all } from 'redux-saga/effects';
import { INTEGRATION } from '../../constants/constant_doc_types';
import { INTEGRATIONTYPE_XERO } from '../../constants/constant_integration_type';
import {
  FETCH_LIST_INTEGRATION,
  SAVE_INTEGRATION,
  FETCH_INTEGRATION_BY_ID,
  DELETE_INTEGRATION,
} from '../../constants/constant_integration';
import {
  getXeroAccounts,
  getXeroTaxRates,
  getPaymentTypesXero,
  getTillMovementTypesXero,
  getTaxGroupsXero,
} from '../../actions/actionCreatorXero';

export default function*(app) {
  try {
    yield all([
      fork(fetchListIntegrationSaga, app),
      fork(saveIntegrationSaga, app),
      fork(fetchIntegrationByIdSaga, app),
      fork(deleteIntegrationSaga, app),
    ]);
  } catch (e) {
    console.error('@saga_integration: ', e.message || e.stack);
    throw e;
  }
}

function* fetchListIntegrationSaga(app) {
  yield takeLatest(FETCH_LIST_INTEGRATION, callFetchListIntegration, app);
}

function* callFetchListIntegration(app, action) {
  yield sagaCommon.fetchListing(app, action, INTEGRATION);
}

function* saveIntegrationSaga(app) {
  yield takeLatest(SAVE_INTEGRATION, callSaveIntegration, app);
}

function* callSaveIntegration(app, action) {
  const { tenant, user } = yield select();
  try {
    yield sagaCommon.showProgressSaveRecord();

    const params = { tenant, user, data: action.data };
    const doc = yield call(apiIntegration.saveIntegration, app, params);
    const id = doc.id;

    browserHistory.push(`/admin/integration/edit/${id}`);
    yield sagaCommon.doneSaveRecord(doc, 'Integration was saved');
    yield sagaCommon.doneDataById(doc);
  } catch (e) {
    yield sagaCommon.showErrorSaveRecord(e);
  }
}

function* fetchIntegrationByIdSaga(app) {
  yield takeLatest(FETCH_INTEGRATION_BY_ID, callFetchIntegrationById, app);
}

function* callFetchIntegrationById(app, action) {
  const { id, silent } = action;
  try {
    if (id) {
      const fetchParams = { docType: INTEGRATION, id };
      yield sagaCommon.showProgressDataById(silent);
      let doc = yield call(apiCommon.getDoc, app, fetchParams);
      if (doc.type.cid === INTEGRATIONTYPE_XERO) {
        const isValidXero = yield call(apiXero.validate, app, fetchParams);
        if (!isValidXero) {
          // Get updated integration
          doc = yield call(apiCommon.getDoc, app, fetchParams);
        } else {
          yield put(getXeroAccounts(id));
          yield put(getXeroTaxRates(id));
          yield put(getPaymentTypesXero());
          yield put(getTillMovementTypesXero());
          yield put(getTaxGroupsXero());
        }
      }
      yield sagaCommon.doneDataById(doc);
    }
  } catch (error) {
    console.error('e', error);    
    yield sagaCommon.showErrorDataById(error, silent);
  }
}

function* deleteIntegrationSaga(app) {
  yield takeLatest(DELETE_INTEGRATION, callDeleteIntegration, app);
}

function* callDeleteIntegration(app, action) {
  yield sagaCommon.showProgressDeleteRecord();
  try {
    const { id } = action;
    if (id) {
      const { id } = action;
      const params = { id };
      yield call(apiIntegration.deleteIntegration, app, params);
      yield sagaCommon.doneDeleteRecord(id, INTEGRATION);
    }
  } catch (error) {
    yield sagaCommon.showErrorDeleteRecord(error);
  }
}
